module.exports = __webpack_public_path__ + "img/logo.d458c7c2.png";